import component from "./CheckInLogin";

export default component;
